import { Modal, Radio } from '@mantine/core';
import React, { useCallback, useEffect, useState } from 'react';
import useLang from 'lang';
import { useApi } from 'api/api-context';
import { GetHelpdeskAreasResponse } from 'api/actions/get-helpdesk-areas/get-helpdesk-areas-response';
import panic from 'panic';

interface ModalLocationProps {
  modalOpened: boolean;
  handleCloseModal: () => void;
  radioValue: string;
  handleRadioChange: (value: string, label: string) => void;
}
/**
 * ModalLocation component
 */
const ModalLocation: React.FC<ModalLocationProps> = ({
  modalOpened,
  handleCloseModal,
  radioValue,
  handleRadioChange,
}) => {
  const { getAction } = useApi();
  const { _t } = useLang();

  const [areas, setAreas] = useState<NonNullable<GetHelpdeskAreasResponse['areas']>>([]);

  const onChange = useCallback(
    (value: string) => {
      const label = areas.find((area) => area.foreignKey === value)?.title || '';
      handleRadioChange(value, label);
    },
    [handleRadioChange, areas]
  );

  useEffect(() => {
    const getAreas = getAction('GetHelpdeskAreas');

    getAreas()
      .then(({ areas = [] }) => setAreas(areas))
      .catch(panic);
  }, [getAction]);

  return (
    <Modal
      variant="secondary"
      opened={modalOpened}
      onClose={handleCloseModal}
      title={_t('Choose location')}
      transitionProps={{ transition: 'slide-up', duration: 400 }}
    >
      <Radio.Group value={radioValue} onChange={onChange}>
        {areas.map((area) => (
          <Radio key={area.foreignKey} value={area.foreignKey} label={area.title} />
        ))}
      </Radio.Group>
    </Modal>
  );
};

export default ModalLocation;
